import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, Input } from '@angular/core';
import {
    AccessType,
    AuthService,
    IncidentReportsClient,
    IncidentReportExportQuery,
    IncidentReportQuery,
    IMyScoreShiftQuery,
    ITrendingQuery,
    PermissionType,
    IncidentReportTrendingQuery,
} from '@services';
import { ScoreDashboardComponent } from '../../../../components/library/score-dashboard/score-dashboard.component';

export function incidentReportPalette(): Record<string, string> {
    const getColor = (name: string) => getComputedStyle(document.body).getPropertyValue(name).trim();
    return {
        ['Yard']: getColor('--bs-success'),
        ['Warehouse']: getColor('--bs-danger'),
        ['MHE']: getColor('--bs-warning'),
        ['Dock']: getColor('--bs-info'),
        ['Office']: getColor('--bs-secondary'),
    };
}

@Component({
    selector: 'app-incident-report-score',
    imports: [CommonModule, ScoreDashboardComponent],
    templateUrl: './incident-report-score.component.html',
})
export class IncidentReportScoreComponent implements OnInit {
    private incidentReportClient = inject(IncidentReportsClient);
    protected authService = inject(AuthService);

    @Input() employeeId: string | null;
    @Input() daysLookBack: number = 0;
    @Input() isObservations: boolean = false;

    palette: Record<string, string> = {};

    loadScoreData = (query: IMyScoreShiftQuery) => {
        return this.incidentReportClient.getIncidentReportScore(
            new IncidentReportQuery({ ...query, isObservations: this.isObservations }),
        );
    };

    loadTrendingData = (query: ITrendingQuery) => {
        return this.incidentReportClient.getIncidentReportTrending(
            new IncidentReportTrendingQuery({ ...query, isObservations: this.isObservations }),
        );
    };

    exportData = (from: Date, to: Date, userId: string | null) => {
        const query = new IncidentReportExportQuery({ from, to, userId, isObservations: this.isObservations });
        return this.incidentReportClient.exportIncidentReport(query);
    };

    get typeLabel(): string {
        return this.isObservations ? 'Observations' : 'Incidents';
    }

    ngOnInit(): void {
        this.palette = incidentReportPalette();

        if (
            !this.authService.checkPermission(
                PermissionType.IncidentReports,
                AccessType.Manage,
            )
        ) {
            this.employeeId = this.authService.userId;
        }
    }
}
